import { Profile } from "../../../core/models/entities/Profile";
import { UpdateProfileDto } from "../../../core/models/entities/UpdateProfileDto";
import { ProfileResponse } from "../responses/ProfileResponse";
import { mapToVendorType } from "./mapOrganizationType";
import { mapToRole } from "./mapRole";

export function mapToProfile(dto: ProfileResponse): Profile {
  return {
    userOrganizationInformations: {
      b2CId: dto.b2CId,
      role: mapToRole(dto.role),
      organizationName: dto.organizationName,
      organizationId: dto.organizationId,
      organizationCurrency: dto.organizationCurrency,
      vendorType: mapToVendorType(dto.vendorType)!,
      hidePrices: dto.hidePrices === true,
      // Only when the API sent it - no key at all otherwise, so the mapped
      // profile is byte-identical while the API flag is off.
      ...(dto.displayMarkupEnabled !== undefined &&
      dto.displayMarkupEnabled !== null
        ? {
            displayMarkup: {
              enabled: dto.displayMarkupEnabled === true,
              percent: Number.isFinite(Number(dto.displayMarkupPercent))
                ? Number(dto.displayMarkupPercent)
                : 0,
            },
          }
        : {}),
    },
    whiteLabelConfigurations: {
      colorHex: dto?.whiteLabelColorHex,
      logoUrl: dto?.whiteLabelLogoUrl,
      whiteLabelCopyrightName: dto.whiteLabelCopyrightName,
      whiteLabelContactEmail: dto.whiteLabelContactEmail,
      whiteLabelContactPhone: dto.whiteLabelContactPhone,
      whiteLabelVendorName: dto.whiteLabelVendorName,
      whiteLabelWebsiteLink: dto.whiteLabelWebsiteLink,
    },
    emailPreferences: {
      emailPreferenceNewDesign: dto.emailPreferenceNewDesign,
      emailPreferenceNewLogos: dto.emailPreferenceNewLogos,
      emailPreferenceNewOrder: dto.emailPreferenceNewOrder,
      emailPreferencePendingOrder: dto.emailPreferencePendingOrder,
      emailPreferenceOrder: dto.emailPreferenceOrder,
    },
    orderOptions: {
      orderOptionsTermsOfDelivery: dto.orderOptionsTermsOfDelivery,
      orderOptionsTermsOfStandardPackaging:
        dto.orderOptionsTermsOfStandardPackaging,
      orderOptionsTermsOfSpecificPackaging:
        dto.orderOptionsTermsOfSpecificPackaging,
      orderOptionsDeliveryCost: dto.orderOptionsDeliveryCost,
      orderOptionsStandardPackagingCost: dto.orderOptionsStandardPackagingCost,
      orderOptionsSpecificPackagingCost: dto.orderOptionsSpecificPackagingCost,
    },
    detailedConfigurations: {
      contactEmail: dto.contactEmail,
      contactPerson: dto.contactPerson,
      contactPhone: dto.contactPhone,
      organizationAddress: dto.organizationAddress,
      organizationCVR: dto.organizationCVR,
      organizationEmail: dto.organizationEmail,
      organizationPhone: dto.organizationPhone,
      organizationPostCode: dto.organizationPostCode,
      organizationCity: dto.organizationCity,
      organizationCountry: dto.organizationCountry,
      organizationLanguage: dto.organizationLanguage,
    },
    shippingPreferences: {
      shippingName: dto.shippingName,
      shippingAddress: dto.shippingAddress,
      shippingPostCode: dto.shippingPostCode,
      shippingCity: dto.shippingCity,
      shippingCountry: dto.shippingCountry,
      shippingContactPerson: dto.shippingContactPerson,
      shippingContactPhone: dto.shippingContactPhone,
      shippingContactEmail: dto.shippingContactEmail,
    },
    // Branding authority: absent (undefined) until the API's branding package
    // is deployed — consumers fall back to the legacy rule in that case.
    brandingAuthorityName: dto?.brandingAuthorityName ?? undefined,
    brandingAuthorityOrgId: dto?.brandingAuthorityOrgId ?? undefined,
    canEditBranding:
      typeof dto?.canEditBranding === "boolean"
        ? dto.canEditBranding
        : undefined,
  };
}

export function mapProfileToUpdateProfileDto(dto: Profile): UpdateProfileDto {
  return {
    whiteLabelColorHex: dto.whiteLabelConfigurations?.colorHex ?? "#7BBB58",
    whiteLabelCopyrightName:
      dto.whiteLabelConfigurations?.whiteLabelCopyrightName,
    whiteLabelContactEmail:
      dto.whiteLabelConfigurations?.whiteLabelContactEmail,
    whiteLabelContactPhone:
      dto.whiteLabelConfigurations?.whiteLabelContactPhone,
    whiteLabelVendorName: dto.whiteLabelConfigurations?.whiteLabelVendorName,
    whiteLabelWebsiteLink: dto.whiteLabelConfigurations?.whiteLabelWebsiteLink,

    emailPreferenceNewDesign: dto.emailPreferences?.emailPreferenceNewDesign,
    emailPreferenceNewLogos: dto.emailPreferences?.emailPreferenceNewLogos,
    emailPreferenceNewOrder: dto.emailPreferences?.emailPreferenceNewOrder,
    emailPreferencePendingOrder:
      dto.emailPreferences?.emailPreferencePendingOrder,
    emailPreferenceOrder: dto.emailPreferences?.emailPreferenceOrder,

    orderOptionsTermsOfDelivery: dto.orderOptions?.orderOptionsTermsOfDelivery,
    orderOptionsTermsOfStandardPackaging:
      dto.orderOptions?.orderOptionsTermsOfStandardPackaging,
    orderOptionsTermsOfSpecificPackaging:
      dto.orderOptions?.orderOptionsTermsOfSpecificPackaging,
    orderOptionsDeliveryCost:
      dto.orderOptions?.orderOptionsDeliveryCost?.toString(),
    orderOptionsStandardPackagingCost:
      dto.orderOptions?.orderOptionsStandardPackagingCost?.toString(),
    orderOptionsSpecificPackagingCost:
      dto.orderOptions?.orderOptionsSpecificPackagingCost?.toString(),

    shippingName: dto.shippingPreferences.shippingName,
    shippingAddress: dto.shippingPreferences.shippingAddress,
    shippingPostCode: dto.shippingPreferences.shippingPostCode,
    shippingCity: dto.shippingPreferences.shippingCity,
    shippingCountry: dto.shippingPreferences.shippingCountry,
    shippingContactPerson: dto.shippingPreferences.shippingContactPerson,
    shippingContactPhone: dto.shippingPreferences.shippingContactPhone,
    shippingContactEmail: dto.shippingPreferences.shippingContactEmail,
  };
}
